import {Ng2StateDeclaration, StateParams} from '@uirouter/angular';
import { ProjectInfoComponent } from './components/project-info/project-info.component';
import { DocumentsToClassifyComponent } from '@app/ps/projects/components/documents-to-classify/documents-to-classify.component';
import { DocumentClassificationComponent } from '@app/ps/projects/components/document-classification/document-classification.component';
import { resolveId } from '@app/common/utils/state.utils';

export const projectInfoState: Ng2StateDeclaration = {
  name: 'symap.project.info',
  data: {
   title: '',
  },
  url: '/info/:tab',
  params: {
    tab: {
      type: 'string',
      value: null,
      dynamic: true,
      inherit: false,
      squash: true,
    }
  },
  views: {
   'content@symap.project': {
     component: ProjectInfoComponent,
   }
  }
};

export const documentsToClassifyState: Ng2StateDeclaration = {
  name: 'symap.project.document-classify',
  data: {
    title: 'Dokumenty k zařazení',
  },
  url: '/documents-classify/{tab:history|documents}',
  params: {
    tab: {
      value: null,
      dynamic: true,
      inherit: false,
      squash: true,
    }
  },
  views: {
    'content@symap.project': {
      component: DocumentsToClassifyComponent,
    }
  }
};

export const documentClassificationState: Ng2StateDeclaration = {
  name: 'symap.project.document-classify.detail',
  url: '/classify/:id',
  data: {
    title: 'Zařazení dokumentu',
  },
  resolve: {
    documentId: [ '$stateParams', resolveId ]
  },
  params: {
    id: {
      type: 'int',
      value: undefined
    },
  },
  views: {
    'content@symap.project': {
      component: DocumentClassificationComponent,
    }
  }
};
